import axios from "axios"
import { toast } from "react-toastify"
import { refreshPage } from "../Utilities/Common"

let config = {
  headers: {
    "api-key": process.env.REACT_APP_API_KEY,
    "Content-Type": "application/json",
  },
}

let fileconfig = {
  headers: {
    "api-key": process.env.REACT_APP_API_KEY,
    "Content-Type": "multipart/form-data",
  },
}

let headers = {
  "api-key": process.env.REACT_APP_API_KEY,
  "Content-Type": "application/json",
}

let headersQR = {
  "api-key": process.env.REACT_APP_API_KEY_QR,
  "Content-Type": "application/json",
}

let Qrfileconfig = {
  headers: {
    "api-key": process.env.REACT_APP_API_KEY_QR,
    "Content-Type": "multipart/form-data",
  },
}

let qrHeaders = {
  "api-key": process.env.REACT_APP_API_KEY_QR,
  "Content-Type": "application/json",
}

let qrPrintHeaders = {
  "api-key": process.env.REACT_APP_KEY_QR_PRINT,
  "Content-Type": "application/json",
}

let QrPOSfileconfig = {
  headers: {
    "api-key": process.env.REACT_APP_KEY_QR_PRINT || process.env.REACT_APP_POS_API_KEY,
    // Don't set Content-Type for FormData - axios will auto-set with boundary
  },
}
// Set up a global response interceptor
// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     // Handle 401 error
//     if (error.response && error.response.status === 401) {
//       localStorage.clear();
//       toast.error("Unauthorized. Logging you out...", { autoClose: 5000 });
//       setTimeout(() => {
//         refreshPage();
//         window.location.href = "/login"; // Redirect to the login page
//       }, 1000);
//     }

//     // Propagate the error to the calling code
//     return Promise.reject(error);
//   }
// );

// API Axios Get Call.
export const getAPICall = (url, data) => {
  return axios.get(url, data, config)
}

export const getWithParamsAPICall = (url, data) => {
  return axios.get(url, { headers: headers, params: data })
}

export const getWithParamsQRAPICall = (url, data) => {
  return axios.get(url, { headers: headersQR, params: data })
}

// API Axios Post Call.
export const postAPICall = (url, data) => {
  return axios.post(url, data, config)
}

// API Axios Post Call with File Config
export const postAPICallwithFile = (url, data) => {
  return axios.post(url, data, fileconfig)
}

// API Axios Put Call.
export const putAPICall = (url, data) => {
  return axios.put(url, data, config)
}
// API Axios Delete Call.
export const deleteAPICall = (url) => {
  return axios.delete(url, config)
}

export const getAPICallGoogle = (url) => {
  return axios.get(url)
}

export const postQrAPICallwithFile = (url, data) => {
  return axios.post(url, data, Qrfileconfig)
}

export const getQrWithParamsAPICall = (url, data) => {
  return axios.get(url, { headers: qrHeaders, params: data })
}

export const postQrAPICall = (url, data) => {
  return axios.post(url, data, { headers: headersQR })
}

export const postQrPrintAPICall = (url, data) => {
  return axios.post(url, data, { headers: qrPrintHeaders })
}

export const postQrPOSAPICallwithFile = (url, data) => {
  return axios.post(url, data, QrPOSfileconfig)
}
